/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Debts_AddInputs */

const en_case_debts_add = /** @type {(inputs: Case_Debts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add debt`)
};

const pt_br2_case_debts_add = /** @type {(inputs: Case_Debts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar débito`)
};

/**
* | output |
* | --- |
* | "Add debt" |
*
* @param {Case_Debts_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debts_add = /** @type {((inputs?: Case_Debts_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debts_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debts_add(inputs)
	return pt_br2_case_debts_add(inputs)
});